import { FunctionComponent, useEffect, useState } from "react";
import { Upload, UploadFileInfo, UploadFileStatus, UploadHttpHeaders, UploadOnAddEvent, UploadOnBeforeRemoveEvent, UploadOnBeforeUploadEvent, UploadOnProgressEvent, UploadOnStatusChangeEvent } from "@progress/kendo-react-upload";
import React from "react";
import { FileApi } from "../../redux/api/FileApi";
import { Constants } from "../../Variables/StaticVariables";
import { FileUploadProps } from "../../types/Props/FileUploadProps";
import { useReduxDispatch, useReduxSelector } from "../../redux/hooks";
import { IFileUpload } from "../../types/File/FileUpload";
import { PartialSpinny } from "../Nav/Spinny";
import {
    Hint,
} from "@progress/kendo-react-labels";
import * as FileSlice from "../../slices/FileSlice";

const FileUpload: FunctionComponent<FileUploadProps> = props => {
    const dispatch = useReduxDispatch()
    const { files } = useReduxSelector(s => s.files)
    const { user } = useReduxSelector(s => s.auth)
    const [token, setToken] = useState('');
    const [error, setError] = useState('');
    //const [files, setFiles] = React.useState<Array<UploadFileInfo>>([]);
    const revUploadUrl = `${Constants.apiRoot}file/${props.FileType}/${props.Primary_Id | 0}`
    const [deleteFile, { isLoading: isDeleting }] = FileApi.useDeleteFileMutation();
    const { data: apifiles, isFetching } = FileApi.useGetFilesQuery({ typeId: props.FileType, primaryId: props.Primary_Id });
    const [refetchFiles] = FileApi.useRefetchFilesMutation();
    const { data: fileSettings } = FileApi.useGetFileSettingsQuery()
    const maxFilesReached = fileSettings && fileSettings?.Max_Files <= apifiles?.length;
    const mountedRef = React.useRef(true)

    const setFiles = (f: UploadFileInfo[]) => {
        const newFiles = f?.map(f1 => {
            return {
                name: f1.name,
                uid: f1.uid,
                size: f1.size,
                extension: f1.extension,
                status: f1.status,
                progress: f1.progress
            } as IFileUpload
        });

        dispatch(FileSlice.SetFiles(newFiles))
    }
    useEffect(() => {
        let newFiles = apifiles?.map(f => {
            return {
                name: f.File_Name,
                uid: f.ID.toString(),
                size: f.Length,
                extension: f.File_Name.substring(f.File_Name.lastIndexOf('.')),
                progress: 100,
                status: UploadFileStatus.Uploaded,
            } as UploadFileInfo
        })
        setFiles(newFiles)
    }, [apifiles]);

    useEffect(() => {
        //console.log('useEffect()', apifiles?.length)
        async function getToken() {
            //let user = await userManager.getUser()
            setToken(user.access_token);
        }
        if (!token)
            getToken();

        return () => { mountedRef.current = false; }
    }, []);
    const onRemove = (event: UploadOnBeforeRemoveEvent) => {
        //event.additionalData = 
        console.log('onRemove', event)

        //Make sure some files aren't uploading
        if (event.files.filter(n => n.status === 3).length > 0) {
            alert('Please wait for files to finish uploading')
            return
        }


        event.files.map(
            f =>
                deleteFile(f.uid).then(e => {
                    //setFiles(event.newState);
                })

        )

    }
    const onProgress = (event: UploadOnProgressEvent) => {
        console.log('progress', event)

        //Clears the current list of files so lets skip this
        //setFiles(event.newState);
    };
    const onAdd = (event: UploadOnAddEvent) => {
        setError('')
        console.log('onAdd', event, fileSettings?.Prohibited)
        let newFiles = event.newState;

        //Moved to onBeforeUpload
        //Validation done on the server
        //remove files too big
        // let fileTooBig = event.affectedFiles.find(f => f.size > fileSettings?.Max_Size * 1024 * 1024)
        // if (fileTooBig) {
        //     setError(`Cannot upload file because file size is too large. Upload limit is ${fileSettings?.Max_Size}Mb`)
        //     newFiles.splice(newFiles.indexOf(fileTooBig), 1)
        // }
        // if (fileSettings?.Prohibited?.length) {
        //     let fileProhibited = event.affectedFiles.find(f => fileSettings?.Prohibited.indexOf(f.extension.replace('.', '')) > -1)
        //     if (fileProhibited) {
        //         setError(`Cannot upload file because the file extension (${fileProhibited.extension}) is prohibited`)
        //         newFiles.splice(newFiles.indexOf(fileProhibited), 1)
        //     }
        // }

        setFiles(newFiles);

    }

    const onStatusChange = (event: UploadOnStatusChangeEvent) => {
        console.log('event.response?.status', event.response?.response, event?.newState)
        if (event.response?.response?.status === 400 || event.response?.response?.status === 500)
            setError(event.response?.response?.data)

        console.log('mountedRef.current = ', mountedRef.current);
        if (mountedRef.current)
            setFiles(event.newState);

        //only refresh the files if they have ALL finished uploading
        if (event.newState.filter(n => n.status === 3 && n.progress < 100).length === 0) {
            console.log('ready to refetchFiles()', apifiles?.length)
            refetchFiles() //Clear the cache'
            console.log('refetchFiles()', apifiles?.length)
        }

    };

    const onBeforeUpload = (event: UploadOnBeforeUploadEvent) => {
        console.log('onBeforeUpload', event.files, event.additionalData)

        let fileTooBig = event.files.find(f => f.size > fileSettings?.Max_Size * 1024 * 1024)
        if (fileTooBig) {
            setError(`Cannot upload file because file size is too large. Upload limit is ${fileSettings?.Max_Size}Mb`)
            files.splice(files.indexOf(fileTooBig), 1)
        }

        if (fileSettings?.Prohibited?.length) {
            let fileProhibited = event.files.find(f => fileSettings?.Prohibited.indexOf(f.extension.replace('.', '')) > -1)
            if (fileProhibited) {
                setError(`Cannot upload file because the file extension (${fileProhibited.extension}) is prohibited`)
                files.splice(files.indexOf(fileProhibited), 1)
            }
        }
    }

    const uploadRef = React.createRef<Upload>();

    return (
        <>
            {error &&
                <div className={"k-messagebox k-messagebox-error"}>
                    {error}
                </div>}
            {(isDeleting || isFetching) && <PartialSpinny />}
            <Hint direction="start">
                {maxFilesReached && fileSettings
                    ? <div className="pr-1 k-text-error">Max file limit reached ({fileSettings?.Max_Files}) </div>
                    : <div className="pr-1">Max file limit: {fileSettings?.Max_Files} </div>}
                <div> | Max file size:{fileSettings?.Max_Size}Mb</div>
            </Hint>
            {/* <button onClick={() => refetch()}>Refetch ({apifiles?.length})</button> */}
            {/* <ExternalDropZone uploadRef={uploadRef} style={{ width: 150, height: 150 }} className="d-inline" /> */}
            <Upload ref={uploadRef}
                className={maxFilesReached ? 'no-add-files' : ''}
                batch={false}
                multiple={true}
                files={files}
                saveHeaders={{ "authorization": ["Bearer " + token] } as UploadHttpHeaders}
                withCredentials={false}
                onAdd={onAdd}
                onBeforeRemove={onRemove}
                onBeforeUpload={onBeforeUpload}
                autoUpload={true}
                saveUrl={revUploadUrl}
                removeUrl={revUploadUrl}
                showActionButtons={true}
                onProgress={onProgress}
                onStatusChange={onStatusChange}
                selectMessageUI={(props) => <div><img className="upload-image" src="./images/button_async_attach.jpg" title="drop files here to attach"></img></div>}

            />
        </>
    )
}

export default FileUpload